export class Label {
    fileName: string;
    content: string;
    contentType: string;
}
